import { SLOTS } from 'types';

export enum ACTIONS {
  SET_AVAILABLE_BETS = 'SET_AVAILABLE_BETS',
}

export interface IBetAvailabilityState {
  availableBets: SLOTS[];
}
